import Vuex from 'vuex';
import Vue from 'vue';
import actions from './action';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);
const state = {
  authority: null, // 存放了token和准考证
  examinee: null,
  currentUser: {}, // 当前用户
  myExam: {}, // 我的考试
  examTimeLeft: null, // 考试剩余时间
  submitConfirm: false, // 点击确定交卷
  serverTime: null, // 当前服务器时间
  examPaper: {}, // 正式考试获取的试卷
  submitAllPaper: false, //交卷成功
};
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});
